module.exports = __webpack_public_path__ + "static/media/sales-stream-panel-close.d985b7b4.svg";